import { reduce } from 'lodash';
import { AccountType } from '@/common/constants';
import { flowTypes } from '@/common/service/page-config';
import { isEmptyVal, safeJSONParse } from '@/utils';
import { couponSourceTypeMap } from '@/views/config/coupon/helper/constant';
import { BillingProductEntry } from '@zoom/billing-extensions';
import { filterNotSupportPlanCodesForThresholdCoupon } from '@/views/config/coupon/helper/utils';

const getCurrentFlowType = (config = {}) => {
  const accountType = config?.accountType;
  const isFreeAccount = [AccountType.ACCOUNT_FREE_WITH_CC, AccountType.ACCOUNT_FREE_WITHOUT_CC].includes(accountType);
  // todo with paid
  return config?.pageConfig?.type || (isFreeAccount ? flowTypes.basic2pro : flowTypes.buyNow);
};

/**
 *
 * @param planCodeList
 * @param defaultValue
 * @return {PreloadDiscountMapBean}
 */
export const transferPlanCodeListToDiscountInfo = (planCodeList = [], defaultValue = {}) => {
  return reduce(planCodeList, (res, planCode) => {
    if (planCode) res[planCode] = { ...defaultValue, planCode };
    return res;
  }, {});
};

// pre config preload coupon data with newBillingConfig
export const preConfigWithCampaign = (config = {}) => {
  if (!isEmptyVal(config.marketingCoupon)) {
    const couponData = safeJSONParse(config.marketingCoupon);

    if (couponData) {
      const { couponSourceType, supportPlanCodeList = [], defaultPlanCodeList = [] } = couponData || {};

      if (couponSourceType === couponSourceTypeMap.threshold) {
        const filteredSupportPlanCodeList = filterNotSupportPlanCodesForThresholdCoupon(supportPlanCodeList);
        // transfer supportPlanCodeList to discountInfo object
        couponData.discountInfo = transferPlanCodeListToDiscountInfo(filteredSupportPlanCodeList);
      }

      couponData.defaultDiscountInfo = transferPlanCodeListToDiscountInfo(defaultPlanCodeList);
    }

    const pageConfig = { ...config?.pageConfig, type: getCurrentFlowType(config) };

    return {
      ...config,
      pageConfig,
      marketingCoupon: couponData,
    };
  }

  if (!isEmptyVal(config.trialCampaignInfo?.campaignList)) {
    const { campaignList } = config.trialCampaignInfo;

    const result = BillingProductEntry.syncPreCheckForProductEntry({entryOptions: campaignList[0]});

    // generate current free trial purchase flow
    if (result?.pageQueryConfig) {
      config.pageConfig = {
        ...config.pageConfig,
        ...result?.pageQueryConfig,
      }
    }
  }

  return config;
};

export const preConfigWithCartId = (config = {}) => {
  /** @type {PreloadWithCartIdResultDto} */
  const preloadCartInfo = config?.preloadCartInfo;

  if (!isEmptyVal(preloadCartInfo)) {
    const pageConfig = {
      ...config?.pageConfig, ...(preloadCartInfo.configData || {}),
      type: getCurrentFlowType(config),
    };

    return {
      ...config,
      pageConfig,
    };
  }

  return config;
};
